import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { SafeComponent } from '@fiverr-private/orca';
import { I18n } from '@fiverr-private/i18n-react';
import { Text } from '@fiverr-private/typography';
import ServiceItem from '../ServiceItem';
import { DEFAULT_POPULAR_SERVICES } from './constants';

interface Props {
    inExpandableSearchBar?: boolean;
}

const PopularServices = ({ inExpandableSearchBar = false }: Props) => (
    <Container width="100%" maxWidth="100%">
        {inExpandableSearchBar && (
            <Container color="white" marginTop="2" marginBottom="4" width="max-content">
                <Text color="white">
                    <I18n k="logged_out_homepage.video_top_banner.browse_popular_categories" />
                </Text>
            </Container>
        )}
        <Stack
            direction="row"
            gap="4"
            wrap={{ default: 'nowrap', sm: 'wrap' }}
            overflow="auto"
            justifyContent="flexStart"
            width="100%"
        >
            {DEFAULT_POPULAR_SERVICES.map(({ elementName, labelKey, href, eventName, isNew }, index) => (
                <ServiceItem
                    elementName={elementName}
                    labelKey={labelKey}
                    href={href}
                    key={href}
                    eventName={eventName}
                    index={index}
                    isNew={isNew}
                />
            ))}
        </Stack>
    </Container>
);

export default SafeComponent(PopularServices);
